import React, { useContext, useState, useEffect } from "react";

import { renderColumn } from "utils/helpers";
import FormHOC from "hoc/FilltersForm";
import CustomizableTable from "components/client/CustomizableTable/CustomizableTable";
import { RtlContext } from "../../../App";

export default FormHOC(({
    data,
    availableColumns,
    pickedColumns,
    savedTableColumns,
    loading,
    more,
    page,
    count,
    service,
    perPage,
    perPageLSKey,
    getItems,
    onSaveColumnsTable,
    extraRows
}) => {
    // const savedTableColumns = [];
    const rtl = useContext(RtlContext);
    const [columns, onChangeColumns] = useState(pickedColumns);
    const [columnsWereChanged, setColumnsWereChanged] = useState(false);

    useEffect(() => {
        onChangeColumns(pickedColumns);
    }, [pickedColumns]);

    const renderedColumns = columns.map(renderColumn);

    return (
        <CustomizableTable
            {...{
                rtl,
                data,
                savedTableColumns,
                count,
                perPage,
                page,
                loading,
                getItems,
                onSaveColumnsTable,
                renderedColumns,
                extraRows
            }}
            onChangeColumns={(newColumns) => {
                setColumnsWereChanged(true);
                onChangeColumns(newColumns);
            }}
            pickedColumns={availableColumns || pickedColumns}
            isChangedColumns={true}
            isPaginated={true}
            perPageLSKey={perPageLSKey}
            rowClassName={rowData => {
                if (rowData && rowData.id === "summaries") {
                    return "summaries";
                }

                return "";
            }}
            moreCount={more}
        />

    );
});
